import { render, staticRenderFns } from "./house.vue?vue&type=template&id=a1841fce&"
import script from "./house.vue?vue&type=script&lang=js&"
export * from "./house.vue?vue&type=script&lang=js&"
import style0 from "./house.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports